module.exports = __webpack_public_path__ + "img/grid-skel.ddb3d19c.png";